import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import TrendingSection from './components/TrendingSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <LatestUpdates />
        <TrendingSection />

        <section className="w-full bg-primary-500 py-12 md:py-14">
          <div className="max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-background-50 dark:text-foreground-950 font-heading">
              加入皮皮喵漫画社区
            </h2>
            <p className="mt-3 text-base text-background-50/90 dark:text-foreground-950/90 max-w-xl mx-auto">
              与千万漫友一起追更讨论，发现更多精彩漫画
            </p>
            <a
              href="/category/series"
              className="mt-6 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即探索
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>
        </section>
      </main>
      <Footer />

      {/* Schema.org Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "name": "皮皮喵漫画",
            "url": "https://pipimao.com",
            "description": "皮皮喵漫画汇集海量韩漫、日漫、国漫与热门系列漫画大全，高清在线免费看，分类齐全，随时追更你喜欢的类型漫画。",
            "potentialAction": {
              "@type": "SearchAction",
              "target": "https://pipimao.com/search?q={search_term_string}",
              "query-input": "required name=search_term_string"
            },
            "publisher": {
              "@type": "Organization",
              "name": "皮皮喵漫画",
              "url": "https://pipimao.com",
              "logo": "https://pipimao.com/logo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "400-888-6666",
                "contactType": "customer service",
                "availableLanguage": "Chinese"
              }
            }
          }),
        }}
      />
    </>
  );
}